import React from "react";
import styles from "./teamList.module.css";

export interface TeamListProps {
  teams: TeamListItem[];
}

export interface TeamListItem {
  name: string;
  description: string;
}

function createListRow(teamListItem: TeamListItem): JSX.Element {
  return (
    <tr key={teamListItem.name}>
      <td className={`${styles["list-row"]} ${styles["awsui-util-pt-s"]}`}>
        <div className={styles["flex-column"]}>
          {teamListItem.name}
          <small>{teamListItem.description}</small>
        </div>
      </td>
    </tr>
  );
}

/**
 * Component that displays a flat list of teams.
 */
const TeamList: React.FC<TeamListProps> = ({ teams }): JSX.Element => {
  const listContent: JSX.Element[] = teams.map((team) => {
    return createListRow(team);
  });
  return (
    <table className={`${styles["list-table"]} ${styles["awsui-util-pt-s"]}`}>
      <tbody className={styles["list-tbody"]}>{listContent}</tbody>
    </table>
  );
};

export default TeamList;
